// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"jX-z","sponsoredTooltipWrapper":"kX-z","sponsoredTooltip":"lX-z","newCard":"mX-z"};